/**
 * Utils Barrel Export
 *
 * Centralized export for all utility functions.
 * Enables cleaner imports across modules.
 */

// Attribute selector utilities
export {
  getSelector,
  querySelectorAll,
  querySelector,
  checkDeprecated,
} from './utils/attributeSelector.ts';

// Height animation utilities
export { animateHeight, setHeight } from './utils/heightAnimator.ts';

// Modal manager utilities
export {
  openModal,
  closeModal,
  onModalOpen,
  onModalClose,
  getActiveModalCount,
  isModalOpen,
} from './utils/modalManager.ts';

// Import config to extract globalConfig
import config from '@config';

// Export globalConfig from master config
export const globalConfig = config._global;

// CSS variables utility (default export becomes named export)
export { default as cssVariables } from './utils/cssVariables.ts';

// GSAP utilities
export {
  getGsap,
  hasGsap,
  hasScrollTrigger,
  hasDraggable,
  resetGsapWarning,
  prefersReducedMotion,
  initScrollVelocityTracking,
  initScrollTriggerRefresh,
  getScrollVelocity,
  getScrollDirection,
  warnMissingDependencies,
  type GsapTimeline,
  type GsapTween,
} from './utils/gsap.ts';

// Orchestrator utility
export {
  createOrchestrator,
  type ModuleRegistryEntry,
  type ModuleInstance,
  type ScanResult,
  type OrchestratorReturn,
} from './utils/orchestrator.ts';

// Webflow platform utilities
export { isWebflow, waitForIx3, shouldSkipWebflow } from './utils/webflow.ts';

// Config types
export { type ModuleConfig } from './config.ts';
